import ServicePageTemplate from "@/components/layout/ServicePageTemplate";

export default function ADUPage() {
  return (
    <div data-testid="adu-page">
      <ServicePageTemplate
        overline="ADU Construction"
        title="Build an ADU with a team that owns every step."
        sub="From concept to keys — design, permits, foundation, framing, mechanicals and finishes under one accountable crew."
        image="https://images.unsplash.com/photo-1759355787121-eaef014a501d"
        serviceTitle="ADU Construction"
        services={[
          "Planning & Design",
          "Permits & City Processing",
          "Foundation Work",
          "Framing",
          "Electrical & Plumbing",
          "HVAC Installation",
          "Interior & Exterior Finishes",
          "Final Completion & Walkthrough",
        ]}
        processSteps={[
          { title: "Design & Planning", text: "We collaborate on a layout that fits your goals, your lot and your budget — before construction starts." },
          { title: "Permits & Approval", text: "Our team coordinates city requirements, submittals and approvals so you don't have to chase paperwork." },
          { title: "Foundation & Framing", text: "Professional crews handle excavation, foundation pour and structural framing on a clean, organized site." },
          { title: "Mechanicals", text: "Plumbing, HVAC and electrical systems are installed and inspected before walls close up." },
          { title: "Finishes", text: "Cabinetry, flooring, paint, fixtures and trim are completed with detail-oriented craftsmanship." },
          { title: "Completion", text: "Final inspections, a thorough cleanup and a walkthrough — your ADU, ready for use." },
        ]}
        benefits={[
          "Increase Property Value",
          "Generate Rental Income",
          "Create Guest Space",
          "Build a Home Office",
          "Expand Living Space",
          "Multi-Generational Housing",
        ]}
        faq={[
          { q: "How long does an ADU build take?", a: "Most ADUs run 4–7 months from permit to completion depending on scope, utilities and city processing time." },
          { q: "Do you handle permits and plans?", a: "Yes — we coordinate design, plans and city approvals as part of our turnkey service." },
          { q: "Can I rent my ADU after it's built?", a: "California allows ADUs to be rented in most jurisdictions. We can connect you with resources for short- and long-term rentals." },
        ]}
      />
    </div>
  );
}
